// Handles EmptyState and ErrorState
import * as React from 'react';
import { DataTable } from '@repo/web-list';
import { defineListPage } from '@repo/list';
import { StatusBadge } from '../../../components/ui/StatusBadge';
import { type ProductTypeListItem } from '../types';

interface ProductListProps {
  data: ProductTypeListItem[];
  total: number;
  page: number;
  limit: number;
  onPageChange: (page: number) => void;
  onRowClick: (data: ProductTypeListItem) => void;
  loading?: boolean;
  error?: string;
}

export function ProductList({
  data,
  total,
  page,
  limit,
  onPageChange,
  onRowClick,
  loading,
  error,
}: ProductListProps) {
  const config = React.useMemo(() => defineListPage<ProductTypeListItem>({
  variant: 'data-table',
  resource: 'items',
    columns: [
      { id: 'productCode', header: 'Product Code', accessor: 'productCode', renderType: 'code' },
      { id: 'displayName', header: 'Display Name', accessor: 'displayName', renderType: 'text' },
      { id: 'isActive', header: 'Status', accessor: 'isActive', renderType: 'boolean' },
      { id: 'version', header: 'Version', accessor: 'version', renderType: 'text' },
    ],
    onRowClick,
    rowActions: [
      {
        label: 'View / Edit Product',
        onClick: onRowClick,
      },
    ],
  }), [onRowClick]);

  return (
    <DataTable onRetry={() => window.location.reload()}
      config={config}
      data={data}
      total={total}
      page={page}
      limit={limit}
      onPageChange={onPageChange}
      loading={loading}
      error={error}
      customRenderers={{
        isActive: (row: ProductTypeListItem) => (
          <StatusBadge
            status={row.isActive ? 'success' : 'info'}
            label={row.isActive ? 'Active' : 'Inactive'}
          />
        ),
        version: (row: ProductTypeListItem) => (
          <span className="text-text-secondary">v{row.version}</span>
        ),
      }}
    />
  );
}
